let apiBase = {
  queryAwardsActDetail: '/api/p/awardsAct/queryDetail',
  queryAwardsActAllType: '/api/p/awardsAct/queryAllType',
  querySuccessApply: '/api/p/awardsAct/querySuccessApply',
  queryWinList: '/api/p/awardsAct/queryWinList',
  

}
let singleAwardsActServerObject = null

class AwardsActServer {
    constructor() {}
    queryAwardsActDetail(params = {}) {
        return $http({
            method: 'get',
            url: apiBase.queryAwardsActDetail,
            params: params,
        })
    }
    queryAwardsActAllType(params = {}) {
      return $http({
          method: 'get',
          url: apiBase.queryAwardsActAllType,
          params: params,
      })
    }
    querySuccessApply(params = {}) {
      return $http({
          method: 'get',
          url: apiBase.querySuccessApply,
          params: params,
      })
    }
    queryWinList(params = {}) {
      return $http({
          method: 'get',
          url: apiBase.queryWinList,
          params: params,
      })
    }
}

function singleAwardsActServer() {
    if (singleAwardsActServerObject === null) {
        singleAwardsActServerObject = new AwardsActServer()
    }
    return singleAwardsActServerObject
}

export default singleAwardsActServer()